@for (navItem of navItems; track navItem) {
    <ng-container>
        <vwui-nav-item
            [href]="navItem.href"
            [iconName]="navItem.iconName"
            [routerLink]="['/' + navItem.href]"
            routerLinkActive="is-active"
            tabindex="-1">
            {{ navItem.label | translate }}
        </vwui-nav-item>
    </ng-container>
}
